import { pointInViewportBounds } from "../../../../helpers/modelBuilder/mbChatPureUtils";
import { sampleRows } from "./sampleRows";

export function selectParcelsForRender({
  parcels,
  viewportBounds,
  selectedParcelIds,
  analysisColorFor,
  canRenderDetailLayer,
  maxRenderedParcels,
}) {
  if (!viewportBounds) return [];
  const all = Array.isArray(parcels) ? parcels : [];
  if (!all.length) return [];

  const visible = all.filter((parcel) => {
    const id = String(parcel?.parcel_id ?? "");
    const isSelected = selectedParcelIds?.has?.(id);
    return (canRenderDetailLayer || isSelected || !!analysisColorFor(id))
      && pointInViewportBounds(parcel, viewportBounds);
  });

  if (visible.length <= maxRenderedParcels) return visible;

  const selectedVisible = [];
  const nonSelectedVisible = [];
  visible.forEach((parcel) => {
    const id = String(parcel?.parcel_id ?? "");
    if (selectedParcelIds?.has?.(id)) selectedVisible.push(parcel);
    else nonSelectedVisible.push(parcel);
  });

  if (selectedVisible.length >= maxRenderedParcels) {
    return sampleRows(selectedVisible, maxRenderedParcels);
  }
  return [...selectedVisible, ...sampleRows(nonSelectedVisible, maxRenderedParcels - selectedVisible.length)];
}
